import styled from 'styled-components';
export const ExpandableSection = styled.div.withConfig({
  displayName: "PastMeetingsMenustyle__ExpandableSection",
  componentId: "gt62ue-0"
})(["background-color:", ";position:absolute;left:0;top:calc(100% - 49px);z-index:1;height:", "px;width:", ";overflow-x:auto;"], ({
  theme
}) => theme.color['fill-surface-raised'], ({
  currentTabHeigth
}) => currentTabHeigth + 49, ({
  isPreviousMeetingsMenuOpen
}) => isPreviousMeetingsMenuOpen ? '100%' : 'auto');